import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	toggleWidget: false,
	userId: null,
	fullScreen: false,
	notification: false,
	advertisement: {
		display: true,
		countDown: 5,
		booking: false,
	},
};

export const widgetSlice = createSlice({
	name: "widget",
	initialState,
	reducers: {
		setToggleWidget: (state, action) => {
			state.toggleWidget = action.payload;
		},
		setUserId: (state, action) => {
			state.userId = action.payload;
		},
		setFullScreen: (state, action) => {
			state.fullScreen = action.payload;
		},
		toggleNotification: (state, action) => {
			state.notification = action.payload;
		},
		toggleAdvertisement: (state, action) => {
			state.advertisement = action.payload;
		},
	},
});

export const {
	setToggleWidget,
	setUserId,
	setFullScreen,
	toggleNotification,
	toggleAdvertisement,
} = widgetSlice.actions;

export default widgetSlice.reducer;
